export const searchTooltipText = 'Search by project name and status';
export const deleteConfirmText = 'Are you sure you want to delete the project(s)?';
export const deleteConfirmDescription = 'Deleting this project will delete all its data including files, tasks, and reports.';
